import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const PromiseNeverForgetPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/hidkZE7pnuDdsYunj1wZ11/Madeleine_Morlet_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mx8mrAg4PHAY8mQEmm1fqb/Madeleine_Morlet_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mP3BR1QUjfT2XqWiEGYhbb/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fuL5gRuHQ6o4ukBGcyeC4x/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/iTtKjejxZ8gXbq4c2FSZDc/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6Gw9GwWqKXSMUoiuLiFzi8/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/w2VR4kTDevX9g4VWqy75cY/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/oboqfQeRz1hrKyvhiJ8C2t/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/54NunmgGGBiT8H5jXwbosk/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/aUjM2G1g7uzGowzRyS6nmq/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/aJDX9cCHFCPgTU3JmVdVqj/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/uUcoSxgZY8LMAxMVvaqcR7/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/49QaNiepi3zdsNCNwcz7AM/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5Lqa4Z1P5dbFyqwaLqC6W2/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dzhUR5M9ixAH3psDyVQZED/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nUgYCnjqQwCb1u5uadst5D/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hvPcgBknPXsC96AV7a7QYT/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4iRJuQPRsahAM41iH1xc5k/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4hm8HENkSXGA4FzLB1XQhG/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/8qWuSgCSu69DPRJH7a1YxW/Madeleine_Morlet_20.jpg'];
  // Create a varied spacing array to make the layout more editorial
  const getSpacing = index => {
    const spacings = [6, 12, 8, 16, 10, 14, 7, 12, 9, 16, 10, 14];
    return spacings[index % spacings.length];
  };
  // Create a varied height array for more visual interest
  const getImagePosition = (index: number) => {
    if (index === 0) return '16vh';
    const positions = ['24vh', '8vh', '20vh', '4vh', '28vh', '12vh', '16vh'];
    return positions[index % positions.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh';
    const sizes = ['75vh', '65vh', '80vh', '70vh', '85vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-481" data-mp="3kogdyqzmnibt">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-482" data-mp="3kmdihrfpgwzp">
        <div className="flex space-x-6" data-id="element-483" data-mp="3fpn4rardidhg">
          <div className="text-base font-normal" data-id="element-484" data-mp="3aqslk7phumwt">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-485" data-mp="3as3oy6f11sne">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-486" data-mp="3ue02oda0u6el">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-487" data-mp="2n17rotrsy58r">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-488" data-mp="u1ra0lgffm4">
        <div className="flex min-w-max" data-id="element-489" data-mp="5ruz0y2eohoi">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-490" data-mp="tgwbcwed0cz2">
            <div className="text-base max-w-[360px] pr-4" data-id="element-491" data-mp="yeo5zy6e2d6y">
              <div data-id="element-492" data-mp="kghmxo63mhrc">I Promise I'll Never Forget (2018 to 2021)</div>
              <div className="text-sm leading-normal mt-4" data-id="element-493" data-mp="kiakmdyqhrn7">
                <em data-id="element-494" data-mp="ogrwfat3nqay">I Promise I'll Never Forget</em> is a love letter to youth.
                This dramatisation of adolescence serves to examine identity and
                personal relationships through the construction of imaginative
                narratives. These images have been made in mid-coast Maine,
                reflecting on how our uncertain and self-conscious times are not
                met alone, but amongst our communities. They hold a mirror to my
                own coming of age, as a foreigner and new mother, experiences
                that have been punctuated by a youthful ambition for friendship
                and concurrent feelings of isolation. How daring it is to make
                such extravagant promises, knowing that memories are as fleeting
                as life itself.
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-495" data-mp="2socuif6inx9p">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-496" data-mp="207a5wuxeab94" data-mpi={index}>
                <img src={image} alt={`I Promise I'll Never Forget - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-497" data-mp="2kwcgs93gtnfg" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-498" data-mp="21zbc6pdtppc1">
        <div className="mb-6" data-id="element-499" data-mp="25z24ixj00dio">
          <div className="text-base mb-4" data-id="element-500" data-mp="260dczane29g4">
            I Promise I'll Never Forget (2018 to 2021)
          </div>
          <div className="text-sm leading-normal" data-id="element-501" data-mp="2awtz5zb12dqk">
            <em data-id="element-502" data-mp="2fx8abq7xe3st">I Promise I'll Never Forget</em> is a love letter to youth. This
            dramatisation of adolescence serves to examine identity and personal
            relationships through the construction of imaginative narratives.
            These images have been made in mid-coast Maine, reflecting on how
            our uncertain and self-conscious times are not met alone, but
            amongst our communities. They hold a mirror to my own coming of age,
            as a foreigner and new mother, experiences that have been punctuated
            by a youthful ambition for friendship and concurrent feelings of
            isolation. How daring it is to make such extravagant promises,
            knowing that memories are as fleeting as life itself.
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-503" data-mp="s00dcfho9d9y">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-504" data-mp="n0nv681qwudp" data-mpi={index}>
              <img src={image} alt={`I Promise I'll Never Forget - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-505" data-mp="n1feaje5ozn3" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-506" data-mp="2cfkgxr792zi6" />
      <style jsx data-id="element-507" data-mp="2cfc4u1iyby81">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default PromiseNeverForgetPage;